/**
 * AES key derivada del password en memoria del runtime JS.
 * No se persiste en sessionStorage / IndexedDB. Si la pestaña se
 * cierra, la key se pierde — el usuario debe re-loguear online para
 * regenerarla y poder leer datos cifrados en IDB.
 */
import { deriveKey } from '../offline/crypto.js';

let cachedKey: CryptoKey | null = null;

export function getCryptoKey(): CryptoKey | null {
  return cachedKey;
}

export function clearCryptoKey(): void {
  cachedKey = null;
}

export async function deriveAndStoreKey(password: string, tenantId: string): Promise<void> {
  cachedKey = await deriveKey(password, tenantId);
}

/**
 * Extrae el claim `tid` de un JWT sin verificar firma. Suficiente para
 * el sub-step de derivacion local — la verificacion real la hace el
 * server en cada request.
 */
export function readTenantFromJwt(token: string): string | null {
  const parts = token.split('.');
  if (parts.length !== 3 || !parts[1]) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json) as { tid?: unknown };
    return typeof payload.tid === 'string' ? payload.tid : null;
  } catch {
    return null;
  }
}
